import { render } from "./enterpriseChannelEdit.vue?vue&type=template&id=ec96720c"
import script from "./enterpriseChannelEdit.vue?vue&type=script&lang=js"
export * from "./enterpriseChannelEdit.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/enterPriseConfig/enterpriseChannelEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ec96720c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ec96720c', __exports__)) {
    console.log('reload')
    api.reload('ec96720c', __exports__)
  }
  
  module.hot.accept("./enterpriseChannelEdit.vue?vue&type=template&id=ec96720c", () => {
    console.log('re-render')
    api.rerender('ec96720c', render)
  })

}


export default __exports__